var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.75,
    cy: 71.75,
    r: 52.15,
    stroke: "#FAC600",
    strokeWidth: 12.6,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(-15 71.75 71.75)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6F61",
    fillRule: "nonzero",
    transform: "translate(53.2 36.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.492 17.494L16.37 48.142a5.605 5.605 0 0 0 6.64 3.236 5.724 5.724 0 0 0 4.182-6.172L23.404 12.03c-.647-5.663-5.762-9.73-11.425-9.082a10.32 10.32 0 0 0-1.543.296C4.82 4.774 1.509 10.568 3.04 16.183c.121.447.272.884.452 1.311z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.749,
    cy: 62.712,
    rx: 6.067,
    ry: 6.158,
    transform: "rotate(-15 25.749 62.712)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.7887165e7c4a90296c2be527b3a5f54e.svg";
export { ForwardRef as ReactComponent };